import React, { useState } from 'react';
import { JourneyClasses } from '../../../styles/JourneyClasses';
import { Button, Dialog, DialogActions, DialogContent, IconButton, Paper, Typography } from '@mui/material';
import AvatarEditDialog from '../../dialogs/AvatarEditDialog';
import UserAvatar from '../../../containers/UserAvatar';
import EditIcon from '@mui/icons-material/Edit';
import JHApi from "../../../utils/JHApi"
import { FIELD_TYPES, SENIORITIES, dateAsString } from '../../../utils/utils';
import { Fields } from '../../Fields';

function InfoField(props) {
    const classes = JourneyClasses();

    let style = props.style || {}

    if (props.fontSize){
        style.fontSize = props.fontSize
    }

    return (
        <div style={{display: 'flex', alignItems: 'center'}}>
            {props.startEdit&&<IconButton size='small' onClick={props.startEdit}>
                <EditIcon fontSize='small'/>
            </IconButton>}
            <Typography style={style} component='span' color='textPrimary' className={classes.infoText}>{props.children}</Typography>
        </div>
    )
}

export default function Profile(props) {
    const { journeyData, freezeHistory, signedDate, cycles, userInfo, isAdmin } = props;

    const avatarSrc = isAdmin ? ((journeyData.avatar && journeyData.avatar.url) ? journeyData.avatar.url : undefined) : ((userInfo.avatar && userInfo.avatar.url) ? userInfo.avatar.url : undefined)

    //const internationalPhone = getInternationalPhone(journeyData.phone || '')
    //const waLink = 'https://wa.me/'+internationalPhone

    const beginServiceDate = journeyData.beginServiceDate || journeyData.dateCreated

    const now = new Date();
    const oneDay = 1000 * 60 * 60 * 24;

    let daysInFreeze = 0
    freezeHistory.forEach(element => {
        if (element.start >= beginServiceDate) {
            daysInFreeze += Math.round((new Date(element.end || now) - new Date(element.start)) / oneDay)
        }
    });

    const daysInServiceEndDate = signedDate ? new Date(signedDate) : now

    //const daysSincelLastPublish = journeyData.lastPublishDate?Math.round((now - new Date(journeyData.lastPublishDate))/oneDay):0
    const daysSinceFirstPartSent = journeyData.firstPartSent ? Math.round((now - new Date(journeyData.firstPartSent)) / oneDay) : 0
    const daysInService = (beginServiceDate ? Math.round((daysInServiceEndDate - new Date(beginServiceDate)) / oneDay) : 0) - daysInFreeze

    const numberOfCycles = cycles ? cycles.length : 0

    const [fieldToEdit, setFieldToEdit] = useState();
    const [error, setError] = useState();
    const [newData, setNewData] = useState({});
    const [disabled, setDisabled] = useState(false);

    const [openAvatarEditDialog, setOpenAvatarEditDialog] = useState(false);

    const handleCloseDialog = () => {
        setFieldToEdit()
    }

    const getValue = (name, defaultValue) => {
        if (newData[name] !== undefined){
            return newData[name]
        } else if (journeyData[name] !== undefined){
            return journeyData[name]
        } else {
            return defaultValue
        }
    }

    const handleChangeTitle = (titleGroup, titleCategories) => {
        if (getValue('title', '')){
            setNewData({...newData, titleGroup, titleCategories})
        } else {
            setNewData({...newData, title:titleGroup, titleGroup, titleCategories})
        }
    }

    const handleChangeField = e => {
        setNewData({...newData,[e.target.name]: e.target.value})
    };

    const handleSaveFields = e => {
        e.preventDefault();

        let paramsToPass = {data:newData}
    
        setDisabled(true)

        JHApi.updatePersonalJourneyData(paramsToPass,(response)=>{
            props.setJourneyData(response.personaljourney);
            setDisabled(false)
            handleCloseDialog()
        }, (error) => {
            setError(error)
            setDisabled(false)
        })
    }

    const handleCloseAvatarEditDialog = () => {
        setOpenAvatarEditDialog(false)
    }

    const handleCloseAvatarEditDialogAndUpdateUser = (newUserData) => {
        props.updateUserData(newUserData);
    };

    let fields = []

    switch(fieldToEdit){
        case 'fullName': {
            fields = [
                {name:'first_name', label:'First name', defaultValue: '', type:FIELD_TYPES.TEXT, sm:12, required: true},
                {name:'last_name', label:'Last name', defaultValue: '', type:FIELD_TYPES.TEXT, sm:12, required: true},
            ]

            break;
        } case 'title': {
            fields = [
                {name:'titleGroup', label:'Professional Title', type:FIELD_TYPES.TITLE, handleChangeTitle, sm:12, required: true},
                {name:'title', label:'Professional Title (Free Text)', defaultValue: '', hide: (!getValue('titleGroup', '') && !getValue('title', '')) , type:FIELD_TYPES.TEXT, sm:12, required: true},
            ]

            break;
        } case 'email': {
            fields = [
                {name:'email', label:'Email', inputType:'email', defaultValue: '', type:FIELD_TYPES.TEXT, sm:12, required: true},
            ]

            break;
        } case 'phone': {
            fields = [
                {name:'phone', label:'Phone', inputType:'tel', defaultValue: '', type:FIELD_TYPES.TEXT, sm:12, required: true},
            ]

            break;
        } case 'seniorityLevel': {
            fields = [
                {name:'seniorityLevel', label:'Seniority', defaultValue: '', type:FIELD_TYPES.SELECT, options:SENIORITIES, sm:12}
            ]

            break;
        } default: {}
    }

    const classes = JourneyClasses();

    return (
        <>
            <Dialog onClose={handleCloseDialog} open={(fieldToEdit!==undefined)} fullWidth maxWidth="xs">
                <form onSubmit={handleSaveFields}>
                    <DialogContent dividers>
                        {(error)&&<Typography color="error">{error}</Typography>}
                        <Fields fields={fields} getValue={getValue} handleChange={handleChangeField}/>
                    </DialogContent>
                    <DialogActions>
                        <Button disabled={disabled} onClick={handleCloseDialog} color="primary" size="small" aria-label="Cancel">
                            Cancel
                        </Button>
                        <Button
                            disabled={disabled}
                            type="submit"
                            variant="outlined"
                            color="primary"
                            size="small"
                            aria-label='Save'
                        >
                            Save
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
                <Paper className={classes.block} style={{height: 'initial'}} elevation={1}>
                    <AvatarEditDialog
                        open={openAvatarEditDialog} 
                        handleClose={handleCloseAvatarEditDialog}
                        handleUpdateUser={handleCloseAvatarEditDialogAndUpdateUser}
                        currAvatar={avatarSrc}/>
                    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                        <div className="profileAvatar" style={{marginTop: 0}} onClick={()=>setOpenAvatarEditDialog(true)}>
                            <UserAvatar firstName={journeyData.first_name} 
                                        lastName={journeyData.last_name} 
                                        avatarSrc={avatarSrc} 
                                        backgroundColor={journeyData.card_color}
                                        className="avatar" />
                            <span className="change">Change</span>
                        </div>
                        <div style={{marginLeft: 16}}>
                            <InfoField fontSize={20} startEdit={()=>setFieldToEdit('fullName')}><strong>{(journeyData.first_name || '') + ' ' + (journeyData.last_name || '')}</strong></InfoField>
                            <InfoField startEdit={()=>setFieldToEdit('title')}>{journeyData.title || 'No title'}</InfoField>
                            <InfoField startEdit={()=>setFieldToEdit('email')} style={{ textTransform: 'unset' }}>{journeyData.email || 'No email'}</InfoField>
                            <InfoField startEdit={()=>setFieldToEdit('phone')}>{journeyData.phone || 'No phone'}</InfoField>
                        </div>
                    </div>
                </Paper>

                <Paper className={classes.block} elevation={1} style={{marginTop: 8, height: 'initial'}}>
                    {journeyData.plan && <InfoField fontSize={20}><strong>{journeyData.plan}</strong></InfoField>}
                    <InfoField>{daysInService} days in service ({dateAsString(new Date(beginServiceDate))})</InfoField>
                    {(daysInFreeze > 0) && <InfoField>{daysInFreeze} days in freeze</InfoField>}
                </Paper>
        
                <Paper className={classes.block} elevation={1} style={{marginTop: 8, height: 'initial'}}>
                    <InfoField fontSize={20}><strong>Cycles</strong></InfoField>
                    <InfoField>{numberOfCycles} {journeyData.cyclesLimit && <> / {journeyData.cyclesLimit}</>}</InfoField>
                    {(journeyData.cyclesLimit && numberOfCycles === journeyData.cyclesLimit)&&<InfoField style={{ color: '#f44336', fontWeight: 'bold' }}>Last Cycle</InfoField>}
                    {(journeyData.firstPartSent !== undefined) && <InfoField>Publication started {daysSinceFirstPartSent} days ago</InfoField>}
                </Paper>
        </>
    )
}